module.exports = __webpack_public_path__ + "img/ionic-md-home.839c31db.svg";